import React from "react";
import { Trans } from "../i18n";

const I18nText = ({ children, ...props }) => (
  <Trans i18nKey={children} {...props} />
);

export default I18nText;
